import { useLocale } from '@wojtekmaj/react-t';

import type { I18nStringMap } from '@rewardopl/types/helpers/i18n';

export default function useI18nText(value: I18nStringMap | undefined, fallbackValue: string) {
  const locale = useLocale();

  return value?.[locale as keyof typeof value] || fallbackValue;
}
